module.exports = __webpack_public_path__ + "img/通威新能源.becec939.png";